import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { EDITOR_SERVICE } from '@core/injection-tokens/editor.injection.token';
import { MojoAutocompleteModule } from 'mojo-autocomplete';
import { MojoEditorModule } from 'mojo-editor';
import { MojoFeatureExtensionsModule } from 'mojo-feature-extensions';
import { MojoMarkSearchPhraseModule } from 'mojo-mark-search-phrase';
import { MojoTagModule } from 'mojo-tag';

import { MaterialModule } from '@material/material.module';
import { LoaderModule } from '@shared/loader/loader.module';

import { AssignToJobComponent } from './assign-to-job.component';

@NgModule({
  imports: [
    CommonModule,
    MojoEditorModule.forRoot(EDITOR_SERVICE),
    MojoAutocompleteModule,
    MojoTagModule,
    LoaderModule,
    ReactiveFormsModule,
    MaterialModule,
    MojoMarkSearchPhraseModule,
    MojoFeatureExtensionsModule,
  ],
  declarations: [AssignToJobComponent],
  exports: [AssignToJobComponent],
})
export class AssignToJobModule {}
